/** One organization member as the Settings payload lists it, and its display helpers. */
export interface MemberRow {
  id: string;
  name: string | null;
  email: string;
  roles: string[];
  status: string;
  /** Invitation email state for pending members (HS2-FZQ46C). */
  invitationSentAt?: string | null;
  invitationError?: string | null;
}

/** What happened to a pending member's invitation email, for the admin. */
export function invitationEmailStatus(m: MemberRow): { text: string; failed: boolean } {
  if (m.invitationError !== undefined && m.invitationError !== null)
    return { text: `Invitation email not sent: ${m.invitationError} Share the sign-in link or resend.`, failed: true };
  if (m.invitationSentAt !== undefined && m.invitationSentAt !== null)
    return { text: `Invitation emailed ${new Date(m.invitationSentAt).toLocaleDateString()}`, failed: false };
  return { text: 'Invitation email not sent yet.', failed: false };
}

/** A member's name, or their email when they have none. */
export function memberDisplayName(m: MemberRow): string {
  return m.name !== null && m.name.trim() !== '' ? m.name.trim() : m.email;
}
